function getInitials(fullName: string) {
  return fullName
    .split(' ')
    .map((word) => word[0])
    .join('')
    .toUpperCase()
    .slice(0, 2); // Limit to maximum 2 characters
}

export default getInitials;
